import { render, staticRenderFns } from "./PZHGoods.vue?vue&type=template&id=1426b334&scoped=true&"
import script from "./PZHGoods.vue?vue&type=script&lang=js&"
export * from "./PZHGoods.vue?vue&type=script&lang=js&"
import style0 from "./PZHGoods.vue?vue&type=style&index=0&id=1426b334&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1426b334",
  null
  
)

export default component.exports